/* eslint-disable */
import React, { useState, useEffect } from "react";
import UsersTable from "./components/usersTable";
import StatCard from "./components/statCard";
import InviteWorkerModal from "./components/inviteWorkerModal";
import PermissionsModal from "./components/permissionsModal";
import {
  changeWorkerPermissions,
  fetchAllWorkers,
  inviteNewWorker,
  removeWorker,
} from "../../api/workers/workers";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import {
  Users,
  UserPlus,
  Settings,
  Trash2,
  Shield,
  Loader2,
} from "lucide-react";
import Navbar from "../../components/navbar/Navbar2";
import Sidebar from "../../components/sidebar/Sidebar2";
import Footer from "../../components/footer/Footer";
import { useTranslation } from "react-i18next";

function WorkersManagement() {
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();
  // Get workers from Redux store
  const workers = useSelector((state) => state.workersReducer.workers);
  const loading = useSelector((state) => state.workersReducer.loading);
  const error = useSelector((state) => state.workersReducer.error);
  const account = useSelector((state) => state.AccountReducer);
  const products = useSelector((state) => state.ProductsReducer);
  console.log(products);
  const name = account?.name;
  const [showInviteModal, setShowInviteModal] = useState(false);
  const [showPermissionsModal, setShowPermissionsModal] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);

  const [showSideBar, setShowSideBar] = useState(true);
  const isRTL = i18n.language === "ar";
  const availablePermissions = [
    {
      id: "orders.create",
      label: t("workersManagement.permissions.orders.create"),
      category: "orders",
    },
    {
      id: "orders.view",
      label: t("workersManagement.permissions.orders.view"),
      category: "orders",
    },
    {
      id: "orders.update",
      label: t("workersManagement.permissions.orders.update"),
      category: "orders",
    },
    {
      id: "orders.delete",
      label: t("workersManagement.permissions.orders.delete"),
      category: "orders",
    },

    {
      id: "products.create",
      label: t("workersManagement.permissions.products.create"),
      category: "products",
    },
    {
      id: "products.view",
      label: t("workersManagement.permissions.products.view"),
      category: "products",
    },
    {
      id: "products.update",
      label: t("workersManagement.permissions.products.update"),
      category: "products",
    },
    {
      id: "products.delete",
      label: t("workersManagement.permissions.products.delete"),
      category: "products",
    },

    {
      id: "workers.create",
      label: t("workersManagement.permissions.workers.create"),
      category: "workers",
    },
    {
      id: "workers.view",
      label: t("workersManagement.permissions.workers.view"),
      category: "workers",
    },
    {
      id: "workers.update",
      label: t("workersManagement.permissions.workers.update"),
      category: "workers",
    },
    {
      id: "workers.delete",
      label: t("workersManagement.permissions.workers.delete"),
      category: "workers",
    },
    {
      id: "workers.manage_permissions",
      label: t("workersManagement.permissions.workers.manage_permissions"),
      category: "workers",
    },

    {
      id: "store.view",
      label: t("workersManagement.permissions.store.view"),
      category: "store",
    },
    {
      id: "store.update",
      label: t("workersManagement.permissions.store.update"),
      category: "store",
    },
    {
      id: "store.updatedesign",
      label: t("workersManagement.permissions.store.updatedesign"),
      category: "store",
    },
  ];

  const roles = [
    {
      value: "confirmer",
      label: t("workersManagement.roles.confirmer"),
      color: "bg-pink-100 text-pink-800",
    },
    {
      value: "delivery",
      label: t("workersManagement.roles.delivery"),
      color: "bg-green-100 text-green-800",
    },
    {
      value: "product_manager",
      label: t("workersManagement.roles.product_manager"),
      color: "bg-blue-100 text-blue-800",
    },
    {
      value: "partner",
      label: t("workersManagement.roles.partner"),
      color: "bg-yellow-100 text-yellow-800",
    },
  ];

  // Fetch workers
  useEffect(() => {
    dispatch(fetchAllWorkers());
  }, [dispatch]);

  const handleInviteUser = async (newWorkerData) => {
    const result = await dispatch(inviteNewWorker(newWorkerData));
    if (result.success) {
      setShowInviteModal(false);
      // refresh workers list
      dispatch(fetchAllWorkers());

      toast.success(t("workersManagement.toasts.inviteSuccess"));
    } else {
      toast.error(result.message || t("workersManagement.toasts.inviteFail"));
    }
  };

  const handleDeleteUser = async (userId) => {
    const confirmResult = await Swal.fire({
      title: t("workersManagement.table.deleteTitle"),
      text: t("workersManagement.dialogs.confirmDeleteUser"),
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: t("workersManagement.table.deleteConfirm"),
      cancelButtonText: t("workersManagement.table.cancel"),
      confirmButtonColor: "#d33",
      cancelButtonColor: "rgb(141, 93, 167)",
      allowOutsideClick: false,
      allowEscapeKey: false,
      backdrop: `rgba(0,0,0,0.7)`,
    });

    if (!confirmResult.isConfirmed) return;

    const deleteResult = await dispatch(removeWorker(userId));
    if (deleteResult.success) {
      toast.success(t("workersManagement.toasts.deleteSuccess"));
    } else {
      toast.error(deleteResult.message || t("workersManagement.toasts.deleteFail"));
    }
  };

  const handleOpenPermissions = (user) => {
    const permissionsArray = user.permissions
      ? Object.keys(user.permissions).filter(
          (key) => user.permissions[key] === true,
        )
      : [];

    setSelectedUser({
      ...user,
      permissions: permissionsArray,
      products: user.products || [],
    });

    setShowPermissionsModal(true);
  };

  const handleTogglePermission = (permissionId) => {
    if (!selectedUser) return;

    const hasPermission = selectedUser.permissions.includes(permissionId);
    const updatedPermissions = hasPermission
      ? selectedUser.permissions.filter((p) => p !== permissionId)
      : [...selectedUser.permissions, permissionId];

    setSelectedUser({
      ...selectedUser,
      permissions: updatedPermissions,
    });
  };

  const handleSavePermissions = async () => {
    const permissionsObject = {};

    availablePermissions.forEach((p) => {
      permissionsObject[p.id] = selectedUser.permissions.includes(p.id);
    });

    const result = await dispatch(
      changeWorkerPermissions(
        selectedUser.id,
        permissionsObject,
        selectedUser.products,
      ),
    );

    if (result.success) {
      toast.success(t("workersManagement.toasts.savePermsSuccess"));
      setShowPermissionsModal(false);
      setSelectedUser(null);
      dispatch(fetchAllWorkers());
    } else {
      toast.error(
        result.message || t("workersManagement.toasts.savePermsFail"),
      );
    }
  };

  const getRoleInfo = (roleValue) =>
    roles.find((r) => r.value === roleValue) || roles[0];

  const getPermissionsByCategory = (category) =>
    availablePermissions.filter((p) => p.category === category);

  const categories = [
    { id: "orders", label: t("workersManagement.categories.orders") },
    { id: "products", label: t("workersManagement.categories.products") },
    { id: "workers", label: t("workersManagement.categories.workers") },
    { id: "store", label: t("workersManagement.categories.store") },
  ];

  // Helper function to count active permissions for a user
  const countActivePermissions = (user) => {
    if (!user.permissions) return 0;
    return Object.values(user.permissions).filter((val) => val === true).length;
  };

  // Calculate active workers count
  const activeWorkersCount = workers.filter((w) => w.isActive === true).length;



  return (
    <div
      className="container-fluid bg-white to-purple-50 min-h-screen dark:!bg-[#141414]"
      dir={isRTL ? "rtl" : "ltr"}
    >
      <div className="row">
        {showSideBar && (
          <div
            style={{
              width: "250px",
              flexShrink: 0,
              transition: "width 0.6s ease",
              boxShadow: "2px 0 10px rgba(0,0,0,0.05)",
            }}
          >
            <Sidebar
              showSideBar={showSideBar}
              setShowSideBar={setShowSideBar}
            />
          </div>
        )}
        <div
          className="px-3 dark:!bg-[#141414]"
          style={{ flex: 1, backgroundColor: "#fbf8fc" }}
        >
          <Navbar showSideBar={showSideBar} setShowSideBar={setShowSideBar} />

          {/* Page Header */}
          <div className="bg-white dark:!bg-[#181819] rounded-xl shadow-sm p-4 m-3 mt-6 border border-[#fbf4ff] dark:!border-[#3c3a3d]">
            <div className="flex flex-wrap items-center justify-between gap-3">
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 bg-[#faf1ff] dark:!bg-[#181819] rounded-lg flex items-center justify-center">
                  <Users className="w-6 h-6 text-[#9e68ba]" />
                </div>
                <div>
                  <h2 className="text-xl font-bold text-[#9e68ba] mb-1">
                    {t("workersManagement.page.title")}
                  </h2>
                  <p className="text-gray-600 dark:text-gray-300 mb-0">
                    {t("workersManagement.page.subtitle")}
                  </p>
                </div>
              </div>
              <button
                type="button"
                onClick={() => setShowInviteModal(true)}
                className="bg-[#9b59bf] hover:bg-[#814a9f] text-white px-6 py-2 rounded-lg transition-colors flex items-center"
              >
                <UserPlus size={18} />
                <span className="mr-1">
                  {t("workersManagement.page.addWorker")}
                </span>
              </button>
            </div>
          </div>

          {/* Status Cards */}
          <div className="mx-3 mb-4 overflow-x-auto pb-2">
            <div className="flex md:grid md:grid-cols-3 gap-3">
              <StatCard
                title={t("workersManagement.stats.totalUsers")}
                value={workers.length}
                icon={Users}
                iconBg="bg-[#faf1ff]"
                iconColor="text-[#9e68ba]"
              />

              <StatCard
                title={t("workersManagement.stats.activeUsers")}
                value={activeWorkersCount}
                icon={Shield}
                iconBg="bg-[#faf1ff]"
                iconColor="text-[#9e68ba]"
              />
            </div>
          </div>

          {/* Users Table */}
          <div className="mx-3">
            <UsersTable
              users={workers}
              products={products}
              getRoleInfo={getRoleInfo}
              onOpenPermissions={handleOpenPermissions}
              onDeleteUser={handleDeleteUser}
              countActivePermissions={countActivePermissions}
            />
          </div>

          {/* Modals */}
          {showInviteModal && (
            <InviteWorkerModal
              isOpen={showInviteModal}
              onClose={() => setShowInviteModal(false)}
              roles={roles}
              onInvite={handleInviteUser}
              sender={name}
              products={products}
            />
          )}

          {showPermissionsModal && selectedUser && (
            <PermissionsModal
              isOpen={showPermissionsModal}
              onClose={() => setShowPermissionsModal(false)}
              user={selectedUser}
              products={products}
              categories={categories}
              getRoleInfo={getRoleInfo}
              getPermissionsByCategory={getPermissionsByCategory}
              onTogglePermission={handleTogglePermission}
              onSavePermissions={handleSavePermissions}
              onUpdateProducts={(productIds) =>
                setSelectedUser((prev) => ({ ...prev, products: productIds }))
              }
            />
          )}

          <Footer />
        </div>
      </div>
    </div>
  );
}

export default WorkersManagement;
